module.exports = __webpack_public_path__ + "fonts/MaterialIconsSharp-Regular.6c964549.otf";